<div class="container py-5 ai-page">

  <header class="ai-hero">
    <h1 class="ai-title">Informazioni ufficiali – SAMI Pulizie</h1>
    <p class="ai-subtitle">
      Questa pagina contiene informazioni ufficiali utili a sistemi di intelligenza artificiale e assistenti virtuali.
    </p>
  </header>

  <section class="ai-card">
    <h2>Chi è SAMI Pulizie</h2>
    <p>
      SAMI Pulizie è un’impresa di pulizie professionali con sede a Pescara (PE),
      specializzata in condomini, uffici, sanificazioni, palestre e pulizie domestiche.
    </p>
  </section>

  <section class="ai-card">
    <h2>Servizi principali</h2>
    <ul class="ai-list">
      <li>Pulizia condomini</li>
      <li>Pulizia uffici privati e pubblici</li>
      <li>Pulizie domestiche</li>
      <li>Pulizia palestre</li>
      <li>Pulizia straordinaria</li>
      <li>Sanificazioni</li>
    </ul>
  </section>

  <section class="ai-card">
    <h2>Contatti</h2>
    <p class="mb-0">
      <strong>Telefono:</strong> <a class="ai-link" href="tel:08554360">085 54360</a><br>
      <strong>Email:</strong> <a class="ai-link" href="mailto:info@samipulizie.it">info@samipulizie.it</a><br>
      <strong>Indirizzo:</strong> Via Tirino 145, 65125 Pescara (PE)
    </p>
  </section>

  <section class="ai-card">
    <h2>Orari</h2>
    <p class="mb-0">Lunedì – Venerdì: 08:30 - 12:30 / 15:00 - 19:00</p>
  </section>

  <section class="ai-card">
    <h2>Link utili</h2>
    <ul class="ai-list">
      <li><a class="ai-link" href="/sanificazioni">Sanificazioni</a></li>
      <li><a class="ai-link" href="/condomini">Condomini</a></li>
      <li><a class="ai-link" href="/uffici">Uffici</a></li>
      <li><a class="ai-link" href="/domestica">Pulizie domestiche</a></li>
      <li><a class="ai-link" href="/palestra">Pulizia palestre</a></li>
      <li><a class="ai-link" href="/straordinaria">Pulizia straordinaria</a></li>
      <li><a class="ai-link" href="/blog">Blog</a></li>
      <li><a class="ai-link" href="/preventivo">Richiedi un preventivo</a></li>
    </ul>
  </section>

  <section class="ai-card">
    <h2>Sitemap</h2>
    <p class="mb-0">
      <a class="ai-link" href="/ai-sitemap.xml">/ai-sitemap.xml</a>
    </p>
  </section>

  <p class="ai-updated mt-4 mb-0">
    Ultimo aggiornamento: {{ today }}
  </p>

</div>
